import Vue from "vue";
import socialMediaService from "../../services/social-media/social-media";
import { SocialMedia } from "../../services/social-media/entities/social-media.interface";
import { SocialMediaState } from "./states/social-media.state.interface";

export default {
  namespaced: true,
  state: {
    socialMedia: []
  },
  getters: {
    getSocialMedia: (state: SocialMediaState) => state.socialMedia
  },
  mutations: {
    setSocialMedia(state: SocialMediaState, socialMedia: Array<SocialMedia>) {
      Vue.set(state, "socialMedia", socialMedia);
    }
  },
  actions: {
    getSocialMedia: async (context: any) => {
      await socialMediaService.getSocialMedia().then((response: any) => {
        context.commit("setSocialMedia", response.data.socialMedia);
      });
    },
    updateSocialMedia: async (context: any, payload: any) => {
      let updated = false;
      await socialMediaService
        .updateSocialMedia(payload)
        .then(async (response: any) => {
          updated = response.data.updated;
          await socialMediaService.getSocialMedia().then((response: any) => {
            context.commit("setSocialMedia", response.data.socialMedia);
          });
        });
      return updated;
    },
    createSocialMedia: async (context: any, payload: any) => {
      let created = false;
      await socialMediaService
        .createSocialMedia(payload)
        .then(async (response: any) => {
          created = response.data.created;
          await socialMediaService.getSocialMedia().then((response: any) => {
            context.commit("setSocialMedia", response.data.socialMedia);
          });
        });
      return created;
    },
    deleteSocialMedia: async (context: any, payload: any) => {
      let deleted = false;
      await socialMediaService
        .deleteSocialMedia(payload)
        .then(async (response: any) => {
          deleted = response.data.deleted;
        });
      return deleted;
    }
  }
};
